import {FaGithub, FaLinkedin, FaGlobe} from "react-icons/fa";
import React from "react";

const Footer = (
  {
    navLinks = ["Home", "About"],
    backGroundColor = "bg-th-blue",
    textColor = "text-th-white",
    fillColor = "fill-th-white",
  }) => {


  return (
    <footer className={`fixed ${backGroundColor} ${textColor} flex flex-col p-2 bottom-0 w-full`}>
      <div className='flex flex-row justify-center'>
      <a href="https://github.com/nvelden" target="_blank" rel="noopener noreferrer">
      <FaGithub className='text-lg mx-2'/>
      </a>
      <a href="https://linkedin.com/in/nielsva/" target="_blank" rel="noopener noreferrer">
      <FaLinkedin className='text-lg'/>
      </a>
      <a href="https://nielsvandervelden.com/" target="_blank" rel="noopener noreferrer">
      <FaGlobe className='text-lg mx-2'/>
      </a>
      </div>
      <div className='flex justify-center'>
      <p className='text-sm'>© Copyright 2022  Niels van der Velden</p>
      </div>
    </footer>
  )
};

export default Footer;